<template>
  <div class="textTip">
    <i class="el-icon-warning icon-warning-class"></i>
    <div class="tipContent">
      <slot></slot>
    </div>
    <i class="el-icon-close icon-close-class" @click="closeTip"></i>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  methods:{
    closeTip(){
      this.$emit('closeTip');
    }
  }
}
</script>
<style lang="less" scoped>
.textTip{
  height:43px;
  width: 100%;
  font-size: 12px;
  overflow: hidden;
  border: 1px solid #961189;
  border-radius: 4px;
  background: rgba(192, 69, 192, 0.1);
  padding: 8px;
  box-sizing: border-box;
  .icon-warning-class{
    font-size: 14px;
    float:left;
    margin: 6px 8px 2px 2px;
    color: @currentColor;
  }
  .tipContent{
    float:left;
    line-height: 27px;
  }
  .icon-close-class{
    float: right;
    cursor: pointer;
    font-size: 14px;
    margin: 5px;
  }
}
</style>